import { AccessDeniedError, UnexpectedError, UnexpectedResultFormatError } from '@/domain/errors'
import { PortalContatos } from '@/domain/usecases'
import { HttpClient, HttpRequest, HttpStatusCode } from '@/data/protocols/http'

export class RemoteGetPortalContatos implements PortalContatos {
  constructor (
    private readonly url: string,
    private readonly httpClient: HttpClient<PortalContatos.Result>
  ) {}

  async get (params: PortalContatos.Params): Promise<PortalContatos.Result> {
    const authParams: HttpRequest = {
      url: `${this.url}/api/portal/contatos`,
      method: 'get',
      params
    }

    const { statusCode, body } = await this.httpClient.request(authParams)

    switch (statusCode) {
      case HttpStatusCode.ok: {
        if (body === null) {
          throw new UnexpectedResultFormatError()
        }
        return body
      }
      case HttpStatusCode.badRequest: throw new UnexpectedError()
      case HttpStatusCode.unauthorized: throw new AccessDeniedError()
      default: throw new UnexpectedError()
    }
  }
}
